import axios from "axios";
import React from "react";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";

const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const FetchingWalletSchemaDetails = async () => {
  const token = await GetWebAccessToken()
  try {
    const details = {
      paymentMethod: "PayOut_Settlements",
      paymentMode: "PayOut_Settlements",
      paymentType: "PayOut_Settlements",
      serviceName: "PayOut",
    };
  
    const response = await axios.post(
      `${baseUrl}/digitalWallet/get/wallet/charges/BY/byDefaultScheme`,
      details, {
        headers:{
          "Content-Type": "Application/json",
          "Cache-Control": "no-cache",
    "Pragma": "no-cache",
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response;

  } catch (error) {
    console.log("Error occured While fatching min and max amount");
  }
};
